/**********************************************************************
 * WARNING: This file was autogenerated by util-protos generateFiles.js
 * Do not manually edit!
 ***********************************************************************/

import {createReactQueryMutationHook} from '../types'
import {updateCustomer} from '../api'

export const useMutationUpdateCustomer = createReactQueryMutationHook('updateCustomer', updateCustomer)
